var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47249 14.5H2.59546L5.41789 14.1437C5.63174 14.1172 5.83026 14.019 5.98115 13.865L10.0982 9.74429L14.2153 5.62362C14.3994 5.4427 14.502 5.19511 14.4999 4.93695C14.5027 4.67865 14.3998 4.43062 14.2151 4.25013L11.7553 1.78158C11.5723 1.60124 11.326 1.5 11.069 1.5C10.8123 1.5 10.5658 1.60124 10.383 1.78158L2.14218 10.0166C1.99161 10.1691 1.89596 10.3675 1.87038 10.5804L1.50784 13.4053C1.47244 13.6824 1.55798 13.9615 1.74265 14.1711C1.92731 14.3806 2.19332 14.5003 2.47249 14.5ZM11.0887 3.80957L12.1827 4.90449L10.9463 6.14203L9.8523 5.05348L11.0887 3.80957ZM3.76717 11.1568L8.49274 6.42711L9.59321 7.51551L4.86765 12.2452L3.61836 12.4007L3.76717 11.1568Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.c7a94554afe9b1a12737b2df89cde456.svg";
export { ForwardRef as ReactComponent };